import React from 'react';
import anime from 'animejs';

const defaultStyle = { opacity: 0, transform: 'translateY(20px)' }
export default class extends React.Component {
  static defaultProps = {
    transitionInDelay: 0,
    transitionDuration: 1500,
    animState: 'entering',
  }
  constructor(props) {
    super(props);
    this.listRef = React.createRef();
  }

  componentDidMount() {
    const { transitionDuration, transitionInDelay } = this.props;
    anime({
      targets: '.animated-item',
      translateY: 0,
      translateZ: 1,
      opacity: 1,
      elasticity: 100,
      duration: transitionDuration,
      delay: (el, i, l) => {
        return transitionInDelay + i * 100;
      }
    });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.animState !== this.props.animState) {
      if (this.props.animState === 'entering') {
        const { transitionDuration, transitionInDelay } = this.props;
        anime({
          targets: '.animated-item',
          translateY: 0,
          translateZ: 1,
          opacity: 1,
          elasticity: 100,
          duration: transitionDuration,
          delay: (el, i, l) => {
            return transitionInDelay + i * 100;
          }
        });
      } else if (this.props.animState === 'exiting') {
        anime({
          targets: '.animated-item',
          translateY: 20,
          translateZ: 1,
          opacity: 0,
          elasticity: 100,
          duration: 1000,
          delay: (el, i, l) => {
            return (l - i - 1) * 100;
          }
        });
      }
    }
  }
  render () {
    const { children } = this.props;
    return (
      <nav className="list" ref={this.listRef}>
        {React.Children.map(children, (child, index) => {
          return (<div className="animated-item" style={defaultStyle}  key={`subitem-${index}`} >{child}</div>);
        })}
      </nav>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/List.js